
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWarningEmpty as ObiWarningEmptyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-warning-empty.js';
 
 
 

 
 export const ObiWarningEmpty = createComponent({
   react: React,
   tagName: 'obi-warning-empty',
   elementClass: ObiWarningEmptyElement,
   events: {
     
   }
  });
 
 